module.exports = __webpack_public_path__ + "static/fonts/Nunito-Black.c664604.woff2";